import { render } from "./confirmarPresupuesto.vue?vue&type=template&id=3c5c2b40&scoped=true"
import script from "./confirmarPresupuesto.vue?vue&type=script&lang=js"
export * from "./confirmarPresupuesto.vue?vue&type=script&lang=js"

import "./confirmarPresupuesto.vue?vue&type=style&index=0&id=3c5c2b40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5c2b40"]])

export default __exports__